var render = function (_h,_vm) {var _c=_vm._c;return _c('transition',{attrs:{"name":"fade","appear":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.props.isVisible),expression:"props.isVisible"}],staticClass:"veil-container"},[_vm._t("contents",[_vm._v("Something to Unveil")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }